function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import InfoDialog from 'swag-client-common/components/info/info-dialog';
import { Button, ButtonFontSize, ButtonSize, ButtonTextTransform, ButtonType } from 'swag-client-common/components/ui/button/button';
import { DemoInventoryWarningTypes } from 'swag-common/constants/chameleon-tours';
import classes from './demo-inventory-warning-popup.scss';
const styles = {
  content: {
    width: '1000px',
    maxWidth: 'none'
  },
  body: {
    textAlign: 'center'
  },
  title: {
    textAlign: 'center'
  }
};
export default class DemoInventoryWarningPopup extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "getWarningText", () => {
      const {
        warningType
      } = this.props;
      switch (warningType) {
        case DemoInventoryWarningTypes.Products:
          {
            return 'Sorry, you are not able to proceed as these products are just for demo purposes to show you how to use the platform.';
          }
        case DemoInventoryWarningTypes.ApprovalFlowActions:
          {
            return 'Sorry, you are not able to approve or reject. This is just for demo purposes to show you how to use the platform.';
          }
        case DemoInventoryWarningTypes.RemoveGiveawayRecipient:
          {
            return 'Sorry, you are not able to delete this submission. This is just for demo purposes to show you how to use the platform.';
          }
        case DemoInventoryWarningTypes.PaymentMethodsAdd:
          {
            return 'Sorry, you are not able to add payment methods to this demo closet as this is just for demo purposes to show you how to use the platform.';
          }
        case DemoInventoryWarningTypes.PaymentMethodsEdit:
          {
            return 'Sorry, you are not able to edit payment methods from this demo closet as this is just for demo purposes to show you how to use the platform.';
          }
        case DemoInventoryWarningTypes.PaymentMethodsRemove:
          {
            return 'Sorry, you are not able to remove payment methods from this demo closet as this is just for demo purposes to show you how to use the platform.';
          }
        case DemoInventoryWarningTypes.GiveawayPayment:
          {
            return 'Sorry, you are not able to proceed with this gift giveaway. This is just for demo purposes to show you how to use the platform.';
          }
        case DemoInventoryWarningTypes.InviteToInventory:
          {
            return 'Sorry, you are not able to invite users to this demo closet as this is just for demo purposes to show you how to use the platform.';
          }
        case DemoInventoryWarningTypes.RemoveShipout:
          {
            return 'Sorry, you are not able to remove shipout from this demo closet as this is just for demo purposes to show you how to use the platform.';
          }
        case DemoInventoryWarningTypes.RenameProduct:
          {
            return 'Sorry, you are not able to rename product from this demo closet as this is just for demo purposes to show you how to use the platform.';
          }
        case DemoInventoryWarningTypes.RenameInventory:
          {
            return 'Sorry, you are not able to rename this demo closet as this is just for demo purposes to show you how to use the platform.';
          }
        case DemoInventoryWarningTypes.GiveawayEnd:
          {
            return 'Sorry, you are not able to end gift giveaway from this demo closet as this is just for demo purposes to show you how to use the platform.';
          }
        case DemoInventoryWarningTypes.TransferProducts:
          {
            return 'Sorry you are not able to transfer. This is just for demo purposes to show you how to use the platform.';
          }
        case DemoInventoryWarningTypes.RevokeAccess:
          {
            return 'Sorry, you are not able to change user role in this demo closet as this is just for demo purposes to show you how to use the platform.';
          }
        case DemoInventoryWarningTypes.GiveawayUploadLinks:
          {
            return 'Sorry, you are not able to upload or change links for the gift giveaway from this demo closet as this is just for demo purposes to show you how to use the platform.';
          }
        case DemoInventoryWarningTypes.GiveawaySingleLink:
          {
            return 'Sorry, you are not able to create or change link for the gift giveaway from this demo closet as this is just for demo purposes to show you how to use the platform.';
          }
        case DemoInventoryWarningTypes.BuyCredits:
          {
            return 'Sorry, you are not able to buy credits for this demo inventory. This is just for demo purposes to show you how to use the platform.';
          }
        case DemoInventoryWarningTypes.WithdrawCredits:
          {
            return 'Sorry, you are not able to proceed as this inventory is just for demo purposes to show you how to use the platform.';
          }
        default:
          {
            return 'Sorry, you are not able to proceed as these products are just for demo purposes to show you how to use the platform.';
          }
      }
    });
    _defineProperty(this, "renderContent", () => {
      const {
        onClose
      } = this.props;
      return /*#__PURE__*/React.createElement("div", {
        className: classes.contentRoot
      }, /*#__PURE__*/React.createElement("h2", {
        className: classes.heading
      }, "This is just a demo inventory!"), /*#__PURE__*/React.createElement("span", {
        className: classes.subheading
      }, this.getWarningText()), /*#__PURE__*/React.createElement("div", {
        className: classes.buttonContainer
      }, /*#__PURE__*/React.createElement(Button, {
        type: ButtonType.primary,
        size: ButtonSize.large,
        fontSize: ButtonFontSize.small,
        className: classes.button,
        onClick: onClose,
        textTransform: ButtonTextTransform.none,
        dataButton: "Close"
      }, "Close")));
    });
  }
  render() {
    const {
      open,
      onClose
    } = this.props;
    return /*#__PURE__*/React.createElement(InfoDialog, {
      dataPopup: "DemoInventoryWarning",
      open: open,
      headerless: true,
      content: this.renderContent(),
      contentClassName: classes.popup,
      bodyStyle: styles.body,
      titleStyle: styles.title,
      contentStyle: styles.content,
      onRequestClose: onClose
    });
  }
}